import typedAction from "data/util/typedAction";
import PropTypes from "prop-types";
import EntityProxy from "data/util/EntityProxy";
import EntityName from "data/util/EntityName";
import ClientId from "data/ClientId";

const MapButtonActions = {
    LAUNCH_DIALOG: typedAction("map-button/launch-dialog", {
        target: PropTypes.instanceOf(EntityProxy).isRequired,
    }),
    AUTOMAP_TO_NEW_MAGIC_CHILD: typedAction("map-button/automap-to-new-magic-child", {
        entityKey: EntityName.propType.isRequired,
        newId: ClientId.propType.isRequired,
        source: PropTypes.instanceOf(EntityProxy).isRequired,
    }),
    AUTOMAP_FROM: typedAction("map-button/automap-from", {
        target: PropTypes.instanceOf(EntityProxy).isRequired,
        source: PropTypes.instanceOf(EntityProxy).isRequired,
    }),
};

export default MapButtonActions;



// WEBPACK FOOTER //
// ./app/data/MapButtonActions.js